import React from 'react';
import { TextField } from '@mui/material';

interface GeneratedImageHostsFieldProps {
  hosts: string[];
  onChange: (hosts: string[]) => void;
}

/** One rule per line: `host` (also matches its subdomains) or `host/path-prefix`. */
export const GeneratedImageHostsField: React.FC<GeneratedImageHostsFieldProps> = ({
  hosts,
  onChange,
}) => (
  <TextField
    label="Allowed image hosts"
    multiline
    minRows={3}
    fullWidth
    value={hosts.join('\n')}
    onChange={(event) => onChange(event.target.value.split('\n'))}
    placeholder={'r2.cloudflarestorage.com/provider-outputs/\nbfl.ai'}
    helperText="One rule per line: host or host/path-prefix. A host also matches its subdomains (bfl.ai covers delivery.us2.bfl.ai); a path prefix limits the rule to that path. Only https URLs on these hosts are fetched when a model returns an image link instead of image data."
    inputProps={{ spellCheck: false, className: 'font-mono text-sm' }}
  />
);
